<template lang="pug">
    ApolloQuery(:query="require('../graphql/Form.gql')", :variables="variables")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.form && data.job)")
            .apply(v-else)
                LayoutBannerBreadCrumb(:locale='locale', :cover="data.form.cover", :title="data.form.title", :name="locale == 'en' ? 'Apply' : '正在申請    '", :prefix="data.form.title", prefix_url="/jobs", :prefix_two="data.job.title", :prefix_two_url="/jobs/ + data.job.id")
                MetaTags(v-bind="data.job.meta_tags")
                form
                    .container.container__padded.container-apply
                        .row.jobInfo
                            .col-12
                                h1 {{data.form.applying_header}}<span>{{jobTitle(data.job.title)}}</span>
                                h3.category(v-if="data.job.categories.length") {{data.job.categories[0].name}}
                        .row
                            .col-12.col-md-6
                                .input
                                    label(for="last_name").input__label {{ data.form.last_name }}:
                                    .input__group
                                        .input__field.input__field-title
                                            select(v-model="form.last_name_title" @change="titleChange").input__select
                                                option(v-for="(title, index) in data.form.last_name_titles") {{title}}
                                        .input__field.input__field-lastName
                                            input(type="text", name="last_name", id="last_name" v-model="form.last_name", v-validate="'required'").input__input
                                    .input__error
                                        .input__error__prefix {{errors.first('prefix')}}
                                        .input__error__last_name {{ errors.first('last_name') }}
                            .col-12.col-md-6
                                .input
                                    label(for="first_name").input__label {{ data.form.first_name }}:
                                    .input__field
                                        input(type="text", name="first_name", id="first_name", v-model="form.first_name", v-validate="'required'").input__input
                                    .input__error {{ errors.first('first_name') }}
                        .row
                            .col-12.col-md-6
                                .input
                                    label(for="phone").input__label {{ data.form.phone }}:
                                    .input__field
                                        input(type="text", name="phone", id="phone", v-validate="'tel|required'", v-model="form.phone").input__input
                                    .input__error {{ errors.first('phone') }}
                            .col-12.col-md-6
                                .input
                                    label(for="email").input__label {{ data.form.email }}:
                                    .input__field
                                        input(type="email", name="email", id="email", v-validate="'email|required'" v-model="form.email").input__input
                                    .input__error {{ errors.first('email') }}
                        .row
                            .col-12
                                .input.input-files
                                    label(for="files").input__label
                                        | {{data.form.upload_file}}:
                                        span.input__remark ( {{data.form.upload_file_remarks}} )
                                    .input__group.input__group-files
                                        .input__field.input__field-file
                                            label(for="file").input__label.input__label-file
                                                .fileIcon
                                                    img(src="../assets/form/upload__icon-1.png")
                                                span {{data.form.upload_file}}
                                            input(type="file", name="file", multiple, @change="filesChange($event.target.files)", id="file", accept=".doc,.docx,.jpg,.jpeg,.png,.pdf,.png,.txt,.xls,.xlsx,.ppt,.pptx", hidden)
                                        .input__field.input__field-file
                                            GDriveSelector(:filesChange="gdriveChange")
                                                label(for="").input__label.input__label-file
                                                    .fileIcon
                                                        img(src="../assets/form/upload__icon-2.png")
                                                    span Google Drive
                                        .input__field.input__field-file
                                            DropboxSelector(:filesChange="dropboxChange")
                                                label(for="").input__label.input__label-file
                                                    .fileIcon
                                                        img(src="../assets/form/upload__icon-3.png")
                                                    span DropBox
                        .row
                            .col-12
                                .input
                                    .input__label
                                        | {{data.form.uploaded_file}}:
                                        span(style="border: none;font-weight:normal;").input__error &nbsp;{{files_error}}
                                    .input__files(v-if="uploadedFiles")
                                        .input__file(v-if="uploadedFiles.length <= 0")
                                        .input__file.file(v-for="(file, index) in uploadedFiles", v-bind:key="index")
                                            .file__icon
                                            .file__name
                                                | {{file.name}} <span class="size" style="float: right">{{file.size}}</span>
                                            .file__action
                                                a.file__button(v-on:click="remove(file)")
                        .row
                            .col-12
                                .input.input-msg
                                    label(for="msg").input__label
                                        | {{data.form.suggestion}}:
                                    .input__field
                                        textarea(name="msg", id="msg", v-model="form.suggestion").input__textarea
                    .container-fluid.container-terms
                        .row
                            .col-12
                                .input.input-terms
                                    label(for="msg").input__label
                                        | {{data.form.notice_header}}:
                                    .input__content(v-html="data.form.notice_body")
                                    .input__field
                                        input(type="checkbox", name="terms", id="terms", v-model="form.notice_checked", v-validate="'required'").input__checkbox
                                        label.input__checkboxText(v-html="replaceUrl(data.form.notice_checkbox)", for="terms")
                                    span.input__error(:style="`border-top: none`") {{ errors.first('terms') }}
                    .container.container-action
                        .row
                            .col-6
                                .action
                                    router-link(:to="`/jobs/${job_id ? job_id : ''}`", :title="data.form.btn_prev").action__button.action__button-back
                                            | {{data.form.btn_prev}}
                            .col-6.text-sm-right
                                a(:title="data.form.btn_apply", @click="onSubmit(data)", :class="button_error && 'action__error'").action__button.action__button-submit
                                    | {{data.form.btn_apply}}
                WidgetHowToJoin(v-if='data.form.page_bottom', v-bind='data.form.page_bottom')
</template>

<script>
    import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
    import GDriveSelector from "../components/GDriveSelector.vue";
    import DropboxSelector from "../components/DropboxSelector.vue";
    import Loading from "../components/Loading.vue";
    import FormDataStore from "../stores/FormDataStore";
    import logTraffic from "../utils/logTraffic";
    import PageNotFound from './PageNotFound';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "Apply",
        props: {
            locale: String,
            jobID: String
        },
        components: {
            MetaTags,
            PageNotFound,
            LayoutBannerBreadCrumb,
            GDriveSelector,
            DropboxSelector,
            Loading
        },
        beforeCreate() {
            FormDataStore.restore()
        },
        data() {
            return {
                form: FormDataStore.data.fields,
                files: FormDataStore.data.files,
                files_error: "",
                button_error: false,
            }
        },
      created() {
        if (FormDataStore.id !== this.jobID) {
          FormDataStore.clear();
          FormDataStore.id = this.jobID;
        }
        this.$validator.extend("tel", {
                validate: value =>
                    new Promise(resolve => {
                        const regExp = /^(?![01])\d{8}$/;
                        resolve({
                            valid: value.match(regExp) !== null
                        });
                    })
            });
            this.$validator.attach({
                name: "prefix", rules: "required", getter: () => this.form.last_name_title
            });
        },
        mounted() {
            this.$validator.localize(this.defaultedLocale, this.error_msgs);
            logTraffic(this.$apollo, this.job_id, 'apply');
        },
        computed: {
            uploadedFiles() {
                return [
                    ...this.files.local,
                    ...this.files.gdrive,
                    ...this.files.dropbox
                ].filter(file => !file.disable);
            },
            localFiles() {
              return this.files.local.filter(file => !file.disable);
            },
            hasInvalidFileType() {
              return !this.localFiles.reduce((valid, file) => this.type(file.file.type) !== '' && valid, true);
            },
            smallestFileSize() {
              return this.uploadedFiles.reduce((smallest, file) => Math.min(smallest, file.sizeBytes), 10000)
            },
            totalFileSize() {
                return this.uploadedFiles.reduce((total, file) => total + file.sizeBytes, 0)
            },
            job_id() {
                return parseInt(this.jobID);
            },
            variables() {
                return {
                    locale: this.locale,
                    job_id: this.job_id ? this.job_id : -1
                };
            },
            error_msgs() {
                return this.locale === 'en' ? FormDataStore.errors.en : FormDataStore.errors.zh;
            },
            defaultedLocale() {
                return this.locale ? this.locale : 'zh';
            }
        },
        watch: {
            locale(locale) {
                this.$validator.localize(locale, this.error_msgs);
            }
        },
        methods: {
            replaceUrl(html) {
                return html.replace(/(<a href=".+")/, '$1 target="_blank"');
            },
            jobTitle(title) {
                const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
                return title.match(REGEX_CHINESE) ? title : ` ${title}`;
            },
            titleChange() {
                this.$validator.validate('prefix')
            },
            filesChange(files) {
                this.files.local = [
                    ...this.files.local,
                    ...Array.from(files).map(this.morphFile)
                ];
                this.validateFiles();
            },
            gdriveChange(files) {
                this.files.gdrive = [
                    ...this.files.gdrive,
                    ...files.map(this.morphGFile)
                ];
                this.validateFiles();
            },
            dropboxChange(files) {
                this.files.dropbox = [
                    ...this.files.dropbox,
                    ...files.map(this.morphDFile)
                ];
                this.validateFiles();
            },
            morphFile(file) {
                return {
                    name: file.name,
                    sizeBytes: file.size,
                    size: this.formatBytes(file.size),
                    disable: false,
                    file,
                };
            },
            morphGFile(file) {
                const type = `.${this.type(file.mimeType)}`;
                let name = file.name;
                if (type && !name.endsWith(type) && !name.match(/(jpeg|jpg)$/))
                  name += type;
                return {
                    name,
                    sizeBytes: file.sizeBytes,
                    size: this.formatBytes(file.sizeBytes),
                    disable: false,
                    file,
                }
            },
            morphDFile(file) {
                return {
                    name: file.name,
                    sizeBytes: file.bytes,
                    size: this.formatBytes(file.bytes),
                    disable: false,
                    file,
                };
            },
            type: (mime) => {
                switch (mime) {
                    case 'text/plain':
                        return 'txt';
                    case 'application/msword':
                        return 'doc';
                    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                        return 'docx';
                    case 'application/vnd.ms-powerpoint':
                        return 'ppt';
                    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                        return 'pptx';
                    case 'application/vnd.ms-excel':
                        return 'xls';
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        return 'xlsx';
                    default:
                        const ext = mime.match(/(jpeg|jpg|png|pdf)/g);
                        return (ext && ext.length) ? ext[0] : '';
                }
            },
            remove(file) {
                file.disable = true;
                this.validateFiles();
            },
            onSubmit(data) {
                const fileValid = this.validateFiles();
                this.$validator.validate().then(valid => {
                    if (valid && fileValid) {
                        FormDataStore.validated = true;
                        this.$router.push('confirm');
                    } else {
                        this.toggleError();
                        setTimeout(this.toggleError, 2000);
                    }
                });
            },
            toggleError() {
                this.button_error = !this.button_error;
            },
            validateFiles() {
                if (this.totalFileSize > 10000000)
                    this.files_error = this.error_msgs.custom.files.size;
                else if (this.uploadedFiles.length > 4)
                    this.files_error = this.error_msgs.custom.files.max;
                else if (this.smallestFileSize < 1000)
                  this.files_error = this.error_msgs.custom.files.minSize;
                else if (this.uploadedFiles.length === 0)
                  this.files_error = this.error_msgs.custom.files.required;
                else if (this.hasInvalidFileType)
                  this.files_error = this.error_msgs.custom.files.type;
                else {
                    this.files_error = '';
                    return true;
                }
                return false;
            },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            }
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"
    .file
        &__icon
            background: url('../assets/form/file__icon.png') center center/ auto 80% #ffffff no-repeat
            &-uploaded
                background-image: url('../assets/form/file__icon-uploaded.png')
        &__button
            background: url('../assets/form/trash__icon.png') center center/ auto 50% #ebebeb no-repeat
    $color-blue: #7bcee2
    .input__select
        text-align: left
    .container-apply
        @include media-breakpoint-down(md)
            padding: 1rem

        h1
            font-size: 2.5rem
            line-height: 1.1
            margin-bottom: 0
            span
                color: $color-blue
                @include media-breakpoint-down(md)
                    display: inline-block
                    width: 100%
                    line-height: 1.2
                    padding-top: .5rem
            @include media-breakpoint-down(md)
                font-size: 1.5rem
        h3
            font-size: 1.5rem

        .jobInfo
            margin-bottom: 1rem

        h2
            line-height: 1.2em
            font-size: 2.25rem
            color: $color-blue
            margin-bottom: 0
            @include media-breakpoint-down(md)
                font-size: 1.25rem

        p
            font-size: 1.5rem
            @include media-breakpoint-down(md)
                font-size: 1.25rem

    .jobInfo
        @include media-breakpoint-down(md)
            margin-bottom: 1rem

    .image
        text-align: center

    .fileIcon
        height: 4rem
        padding-bottom: 1rem

        img
            width: auto
            height: 100%

    .container-terms
        background: #f1f1f1
        margin-bottom: 5rem
        @include media-breakpoint-down(md)
            margin-bottom: 2rem

    .container-action
        margin-bottom: 5rem
        @include media-breakpoint-down(md)
            margin-bottom: 2rem

    .input
        &__field-file
            background-color: transparent
            transition: background-color .25s
            padding: 0
            &:hover
                background-color: rgba(0, 0, 0, 0.1)

        &__label-file
            width: 100%
            padding: 1.5rem 0 1rem
            &:hover span
                text-decoration: underline

        &__error
            div
                display: inline-block
            &__prefix
                min-width: 30%
                padding-right: .5rem

    .action__button
        transition: background-color 500ms ease-in-out, border-color 500ms

    .action__error
        border-color: #bd0000
        background-color: #bd0000
        animation: shake 200ms 2 linear
        &:before
            opacity: 0 !important

    @keyframes shake
        0%
            transform: translate(6px, 0)
        50%
            transform: translate(-6px, 0)
        100%
            transform: translate(0, 0)


    a
        cursor: pointer

    .file

        &__icon
            min-width: 35px
            background: url('../assets/form/file__icon.png') center center/ auto 80% #ffffff no-repeat

            &-uploaded
            background-image: url('../assets/form/file__icon-uploaded.png')

        &__button
            background: url('../assets/form/trash__icon.png') center center/ auto 50% #ebebeb no-repeat
</style>

<style lang="sass">
    .picker.shr-q-shr-r-shr-td.picker-dialog-content
        @media (max-width: 576px)
            height: 80vh !important
</style>
